import React from 'react';
import './OverdueTasksModal.css';

const OverdueTasksModal = ({ isOpen, onClose, overdueTasks, onViewTasks }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'No due date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getDaysOverdue = (dueDate) => {
    if (!dueDate) return 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);
    const diffTime = today - due;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  return (
    <div className="overdue-modal-overlay">
      <div className="overdue-modal-content">
        <button className="overdue-modal-close-btn" onClick={onClose}>×</button>
        <h2 className="overdue-modal-title">⚠️ Overdue Tasks</h2>
        <p className="overdue-modal-description">
          You have {overdueTasks.length} {overdueTasks.length === 1 ? 'task' : 'tasks'} that are overdue.
        </p>

        <div className="overdue-tasks-list">
          {overdueTasks.length > 0 ? (
            <div className="overdue-tasks-container">
              {overdueTasks.slice(0, 10).map((task) => (
                <div key={task.id} className="overdue-task-item">
                  <div className="overdue-task-header">
                    <h4 className="overdue-task-title">{task.title || 'Untitled Task'}</h4>
                    <span className="overdue-badge">
                      {getDaysOverdue(task.dueDate)} {getDaysOverdue(task.dueDate) === 1 ? 'day' : 'days'} overdue
                    </span>
                  </div>
                  {task.planName && (
                    <p className="overdue-task-plan">Plan: {task.planName}</p>
                  )}
                  <div className="overdue-task-meta">
                    <span className="overdue-task-date">Due: {formatDate(task.dueDate)}</span>
                    {task.priority && (
                      <span className={`overdue-task-priority priority-${task.priority}`}>
                        {task.priority}
                      </span>
                    )}
                  </div>
                </div>
              ))}
              {overdueTasks.length > 10 && (
                <p className="overdue-more-tasks">
                  ...and {overdueTasks.length - 10} more {overdueTasks.length - 10 === 1 ? 'task' : 'tasks'}
                </p>
              )}
            </div>
          ) : (
            <p className="overdue-no-tasks">No overdue tasks found.</p>
          )}
        </div>

        <div className="overdue-actions">
          <button
            className="view-overdue-btn"
            onClick={onViewTasks}
            disabled={overdueTasks.length === 0}
          >
            View All Overdue Tasks
          </button>
          <button className="close-overdue-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverdueTasksModal;

